import { render, staticRenderFns } from "./subject-form-6.vue?vue&type=template&id=749e96be&scoped=true&"
import script from "./subject-form-6.vue?vue&type=script&lang=ts&"
export * from "./subject-form-6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749e96be",
  null
  
)

export default component.exports